import React, { useState, useEffect } from "react";
import { getSettings } from "../../../services/settingsService";
import { toast } from "react-toastify";


const ApisConfig = ({ apisConfig, setApisConfig }) => {
    console.log("apisConfig :", apisConfig);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setApisConfig(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        getSettings().then(settings => {
            console.log(settings);
            setApisConfig(settings);
        });
    }, []);

    

    const Field = ({ label, name, type = "text", placeholder }) => (
        <div className="form-group" style={{ marginBottom: '16px' }}>
            <label htmlFor={name} style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>{label}</label>
            <input
                id={name}
                name={name}
                type={type}
                className="form-control"
                value={apisConfig?.[name] || ""}
                onChange={handleChange}
                placeholder={placeholder}
                autoComplete="off"
            />
        </div>
    );
    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show">
                <div className="dc-yourdetails dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Apis Config</h3>
                        <p>Manage Apis settings for your website pages</p>
                    </div>

                    {/* OAuth Providers */}
                    <div className="apis-list" style={{ marginBottom: '30px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h4 style={{ margin: 0 }}>OAuth Providers</h4>
                            <span style={{ 
                                padding: '4px 12px', 
                                background: '#e1f5fe', 
                                color: '#01579b', 
                                borderRadius: '15px', 
                                fontSize: '12px', 
                                fontWeight: 'bold' 
                            }}>
                                API Integration Settings
                            </span>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-12" style={{ marginBottom: '25px' }}>
                                <div style={{ 
                                    background: '#f0f7ff', 
                                    padding: '24px', 
                                    borderRadius: '12px', 
                                    border: '2px solid #007bff' 
                                }}>
                                    <h5 style={{ color: '#007bff', marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                                        <i className="ti-facebook" style={{ marginRight: '10px', fontSize: '20px' }}></i>
                                        REQUIRED: Facebook Login Redirect URI
                                    </h5>
                                    <p style={{ fontSize: '14px', color: '#444', marginBottom: '15px' }}>
                                        To enable Facebook Login and Posting, you <strong>must</strong> copy the URL below and paste it into your 
                                        <strong> Facebook Developer Console</strong> under:
                                        <br/>
                                        <span style={{ color: '#007bff', fontWeight: 'bold' }}>Facebook Login for Business &gt; Settings &gt; Valid OAuth Redirect URIs</span>
                                    </p>
                                    <div className="dc-formtheme dc-userform" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '100%' }}>
                                            <div style={{ flex: 1, position: 'relative' }}>
                                                <input 
                                                    readOnly 
                                                    className="form-control" 
                                                    value={`${window.location.origin}/oauth-callback`} 
                                                    style={{ 
                                                        backgroundColor: '#ffffff', 
                                                        fontWeight: 'bold', 
                                                        color: '#1c1e21', 
                                                        fontSize: '14px',
                                                        border: '2px solid #007bff',
                                                        height: '45px',
                                                        padding: '0 15px',
                                                        width: '100%',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>
                                            <button 
                                                type="button"
                                                className="dc-btn" 
                                                style={{ 
                                                    height: '45px', 
                                                    padding: '0 20px', 
                                                    fontSize: '13px', 
                                                    backgroundColor: '#007bff',
                                                    color: '#fff',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    whiteSpace: 'nowrap',
                                                    minWidth: '150px'
                                                }}
                                                onClick={() => {
                                                    navigator.clipboard.writeText(`${window.location.origin}/oauth-callback`);
                                                    toast.success("Redirect URI copied! Now paste it in Facebook Console.");
                                                }}
                                            >
                                                Copy Redirect URI
                                            </button>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: '15px', padding: '10px', background: '#fff', borderRadius: '6px', border: '1px dashed #007bff' }}>
                                        <small style={{ color: '#555' }}>
                                            <strong>Pro Tip:</strong> In Facebook Console, also ensure <strong>"Web OAuth login"</strong> and <strong>"Enforce HTTPS"</strong> are set to <strong>Yes</strong>.
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                                    <i className="fab fa-facebook" style={{ color: '#1877F2', marginRight: '8px' }}></i>
                                    Facebook Integration
                                </h5>
                                <Field label="Facebook App ID" name="facebook_client_id" placeholder="e.g. 1234567890" />
                                <Field label="Facebook App Secret" name="facebook_client_secret" type="password" placeholder="Enter App Secret" />
                                <Field label="Facebook OAuth Redirect URI" name="facebook_redirect_uri" placeholder="e.g. https://your-domain.com/oauth-callback" />
                            </div>
                            
                            <div className="col-sm-12 col-md-6">
                                <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                                    <i className="fab fa-google" style={{ color: '#DB4437', marginRight: '8px' }}></i>
                                    Google Integration
                                </h5>
                                <Field label="Google Client ID" name="google_client_id" placeholder="xxxxx.apps.googleusercontent.com" />
                                <Field label="Google Client Secret" name="google_client_secret" type="password" placeholder="Enter Client Secret" />
                                <Field label="Google OAuth Redirect URI" name="google_redirect_uri" placeholder="e.g. https://your-domain.com/oauth-callback" />
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: 30 }}>
                            <div className="col-sm-12 col-md-6">
                                <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                                    <i className="fab fa-linkedin" style={{ color: '#0A66C2', marginRight: '8px' }}></i>
                                    LinkedIn Integration
                                </h5>
                                <Field label="LinkedIn Client ID" name="linkedin_client_id" placeholder="Client ID" />
                                <Field label="LinkedIn Client Secret" name="linkedin_client_secret" type="password" placeholder="Enter Client Secret" />
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                                    <i className="fab fa-instagram" style={{ color: '#E4405F', marginRight: '8px' }}></i>
                                    Instagram Integration
                                </h5>
                                <Field label="Instagram Client ID" name="instagram_client_id" placeholder="Client ID" />
                                <Field label="Instagram Client Secret" name="instagram_client_secret" type="password" placeholder="Enter Client Secret" />
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: 30 }}>
                            <div className="col-sm-12 col-md-6">
                                <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                                    <i className="fab fa-twitter" style={{ color: '#1DA1F2', marginRight: '8px' }}></i>
                                    Twitter / X Integration
                                </h5>
                                <Field label="Twitter API Key (Client ID)" name="twitter_client_id" placeholder="OAuth 2.0 Client ID" />
                                <Field label="Twitter API Secret (Client Secret)" name="twitter_client_secret" type="password" placeholder="Enter Client Secret" />
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                                    <i className="fab fa-youtube" style={{ color: '#FF0000', marginRight: '8px' }}></i>
                                    YouTube Integration
                                </h5>
                                <Field label="YouTube API Key" name="youtube_api_key" placeholder="Browser API key" />
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: 30 }}>
                            <div className="col-sm-12 col-md-12">
                                <h5 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
                                    <i className="ti-settings" style={{ marginRight: '8px' }}></i>
                                    Global API Settings
                                </h5>
                                <Field label="Global OAuth Redirect Base URL" name="oauth_redirect_base_url" placeholder="e.g. https://your-domain.com" />
                                <div style={{ 
                                    padding: '12px', 
                                    background: '#fff9db', 
                                    border: '1px solid #ffe066', 
                                    borderRadius: '4px', 
                                    fontSize: '12px', 
                                    color: '#856404' 
                                }}>
                                    <strong>Note:</strong> The final redirect URL for all providers will be structured as: 
                                    <code> {apisConfig?.oauth_redirect_base_url || window.location.origin}/oauth-callback</code>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApisConfig;
